import LoggedInHomePageHelper from "../modules/LoggedInHomePageHelper";
import PropTypes from "prop-types";
import React from "react";

export default class Greeting extends React.PureComponent {
  static propTypes = {
    "comingOffHoldIsBlocked": PropTypes.bool.isRequired,
    "customerName": PropTypes.string.isRequired,
    "scenario": PropTypes.string.isRequired
  };

  static hasSet () {
    return (
      <div>
        {this.greetingStatement("We hope you're enjoying your set!")}
      </div>
    );
  }

  static newMember () {
    return (
      <div>
        {this.greetingStatement("Wishlist styles you love to let us get to know you")}
        {LoggedInHomePageHelper.primaryCta("Add to wish list", "/jewelry", "add-to-wish-list-cta")}
      </div>
    );
  }

  static inCuration () {
    return (
      <div>
        {this.greetingStatement("We'll email you when your set is ready to preview")}
      </div>
    );
  }

  static afterPreviewBeforeShipped () {
    return (
      <div>
        {this.greetingStatement("We are tying the bow before it ships!")}
      </div>
    );
  }

  static generic () {
    return (
      <div>
        {this.greetingStatement("We hope you're enjoying Rocksbox")}
      </div>
    );
  }

  static cancelled () {
    return (
      <div>
        {LoggedInHomePageHelper.primaryCta("Shop Now", "/jewelry", "shop-now-cta")}
      </div>
    );
  }

  static onHold () {
    return (
      <div>
        {LoggedInHomePageHelper.primaryCta("Shop Now", "/jewelry", "shop-now-cta")}
      </div>
    );
  }

  static incompleteSignup () {
    return (
      <div>
        {LoggedInHomePageHelper.primaryCta("Shop Now", "/jewelry", "shop-now-cta")}
      </div>
    );
  }

  static subscriptionEnded () {
    return (
      <div>
        {this.greetingStatement("Thanks for being a valued Rocksbox member!")}
      </div>
    );
  }

  static greetingStatement (content) {
    return (
      <div>
        <p className="center mt0">
          {content}
        </p>
      </div>
    );
  }


  static inTransit () {
    return (
      <div>
        {this.greetingStatement("Yay! New jewelry is on the way!")}
      </div>
    );
  }

  preview () {
    return (
      <div>
        {this.constructor.greetingStatement("You have 24 hours to preview your set!")}
      </div>
    );
  }

  greetingContent () {
    const {
      comingOffHoldIsBlocked,
      scenario
    } = this.props;

    switch (scenario) {
    case "in_transit":
      return this.constructor.inTransit();
    case "has_set":
      return this.constructor.hasSet();
    case "new_member":
      return this.constructor.newMember();
    case "in_curation":
      return this.constructor.inCuration();
    case "preview":
      return this.preview();
    case "after_preview_before_shipped":
      return this.constructor.afterPreviewBeforeShipped();
    case "generic":
      return this.constructor.generic();
    case "subscription_ended":
      return this.constructor.subscriptionEnded();
    case "cancelled":
      return (
        <div
          className="flex-center"
        >
          { this.constructor.cancelled() }
        </div>
      );
    case "on_hold":
      return this.constructor.onHold(comingOffHoldIsBlocked);
    case "incomplete_signup":
      return this.constructor.incompleteSignup();
    default:
      return null;
    }
  }

  render () {
    const {customerName} = this.props;

    return (
      <div>
        <h1 className="hey-greeting">
          Hey
          {" "}
          {customerName}
        </h1>
        <div className="greeting-content">
          {this.greetingContent()}
        </div>
      </div>
    );
  }
}
